import { render, staticRenderFns } from "./TabTrash.vue?vue&type=template&id=362217d3&scoped=true&"
import script from "./TabTrash.vue?vue&type=script&lang=js&"
export * from "./TabTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362217d3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362217d3')) {
      api.createRecord('362217d3', component.options)
    } else {
      api.reload('362217d3', component.options)
    }
    module.hot.accept("./TabTrash.vue?vue&type=template&id=362217d3&scoped=true&", function () {
      api.rerender('362217d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/IntelligentBooking/components/TabTrash.vue"
export default component.exports